import React from "react";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";

import styles from "./SimpleFormModal.module.css";

// Components
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import ToClose from "../../components/ToClose/ToClose";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import HeadingAndData from "../../components/HeadingAndData/HeadingAndData";

// Icons (if needed)
import { FaUsers } from "react-icons/fa";

const SimpleFormModal = ({
  icon,
  heading = "Title",
  fieldLabel = "Label",
  fieldName = "field",
  fieldPlaceholder = "Enter value",
  fieldValue,
  onChange,
  onSave,
  saveLabel = "Save",
  onCancel,
  customField = null, // ✅ NEW: optional JSX override or extra content
}) => {
  const dispatch = useDispatch();

  return (
    <div className={styles.cardContainer}>
      <div className={styles.header}>
        <HeadingAndIcon icon={icon} heading={heading} />
        <ToClose onClose={() => dispatch(closeModal())} />
      </div>

      <div className={styles.body}>
        {/* ✅ Render custom content (e.g., textarea) if provided */}
        {customField && <div>{customField}</div>}

        {/* ✅ Still show default input field (existing logic untouched) */}
        <HeadingAndData
          label={fieldLabel}
          name={fieldName}
          placeholder={fieldPlaceholder}
          value={fieldValue}
          onChange={onChange}
          required
        />

        <div className={styles.actions}>
          <SaveAndCancel
            saveLabel={saveLabel}
            onSave={onSave}
            onCancel={onCancel}
          />
        </div>
      </div>
    </div>
  );
};

export default SimpleFormModal;
